import angular from 'angular'

let components = angular
  .module('app.components', [

  ])

module.exports = components;



// WEBPACK FOOTER //
// ./src/app/components/components.js